import { ActionTypes, Actions } from '../actions/actions-dashboard';
import { State } from '../states/dashboard-state';

export function reducer(state, action: Actions): State {
  switch (action.type) {
    case ActionTypes.SetCurrentChart: {
      return {
        ...state,
        currentStatisticsLoading: true
      };
    }

    case ActionTypes.SetOneYearAgoChart: {
      return {
        ...state,
        oneYearAgoStatisticsLoading: true
      };
    }

    case ActionTypes.SetTwoYearsAgoChart: {
      return {
        ...state,
        twoYearsAgoStatisticsLoading: true
      };
    }

    case ActionTypes.SetTopRates: {
      return {
        ...state,
        topRatesLoading: true
      };
    }

    case ActionTypes.SetSubTopRatesCity: {
      return {
        ...state,
        subTopRatesCityLoading: true
      };
    }

    case ActionTypes.SetSubTopRatesHotel: {
      return {
        ...state,
        subTopRatesHotelLoading: true
      };
    }

    case ActionTypes.SetCurrentChartSuccess: {
      return {
        ...state,
        currentKps: action.kpis,
        currentStatistics: action.statistics,
        currentStatisticsLoading: false
      };
    }

    case ActionTypes.SetCurrentChartError: {
      return {
        ...state,
        isError: true,
        currentStatisticsLoading: false
      };
    }

    case ActionTypes.SetOneYearAgoChartSuccess: {
      return {
        ...state,
        previouseYearKps: action.kpis,
        oneYearAgoStatistics: action.statistics,
        oneYearAgoStatisticsLoading: false
      };
    }

    case ActionTypes.SetOneYearAgoChartError: {
      return {
        ...state,
        isError: true,
        oneYearAgoStatisticsLoading: false
      };
    }

    case ActionTypes.SetTwoYearsAgoChartSuccess: {
      return {
        ...state,
        twoYearsAgoStatistics: action.statistics,
        twoYearsAgoStatisticsLoading: false
      };
    }

    case ActionTypes.SetTwoYearsAgoChartError: {
      return {
        ...state,
        isError: true,
        twoYearsAgoStatisticsLoading: false
      };
    }

    case ActionTypes.SetTopRatesSuccess: {
      return {
        ...state,
        topRates: action.rate,
        topRatesLoading: false
      };
    }

    case ActionTypes.SetSubTopRatesCitySuccess: {
      return {
        ...state,
        subTopRatesCity: action.rates,
        subTopRatesCityLoading: false
      };
    }

    case ActionTypes.SetSubTopRatesHotelSuccess: {
      return {
        ...state,
        subTopRatesHotel: action.rates,
        subTopRatesHotelLoading: false
      };
    }

    case ActionTypes.SetTopRatesError: {
      return {
        ...state,
        isError: true,
        topRatesLoading: false
      };
    }

    case ActionTypes.SetSubTopRatesCityError: {
      return {
        ...state,
        isError: true,
        subTopRatesCityLoading: false
      };
    }

    case ActionTypes.SetSubTopRatesHotelError: {
      return {
        ...state,
        isError: true,
        subTopRatesHotelLoading: false
      };
    }

    case ActionTypes.StoreStatisticsFilters: {
      return {
        ...state,
        statisticFilter: action.filters
      };
    }

    case ActionTypes.RequestBookingOffices: {
      return {
        ...state,
        officesRequestSending: true
      };
    }

    case ActionTypes.RequestBookingOfficesSuccess: {
      return {
        ...state,
        officesRequestSending: false,
        allOfficeIds: action.offices
      };
    }

    case ActionTypes.RequestBookingOfficesError: {
      return {
        ...state,
        isError: true,
        officesRequestSending: false
      };
    }

    case ActionTypes.ClearAllStatistics: {
      return {
        ...state,
        currentKps: null,
        previouseYearKps: null,
        currentStatistics: null,
        oneYearAgoStatistics: null,
        twoYearsAgoStatistics: null,
        topRates: null
      };
    }

    default: {
      return state;
    }
  }
}
